import React from "react";

export function TtlsChats(props) {
  return <h6 className="ttlsChats text fnt_medium ">{props.title}</h6>;
}
